/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'confluence-analytics-chart.default-loading-text': 'Actualizando datos de análisis...',
  'confluence-analytics-chart.tooltip.no-views-data': 'No hay datos',
  'confluence-analytics-chart.tooltip.views-overall':
    '{count, plural, one {1 visualización} other {{count} visualizaciones}}',
  'confluence-analytics-chart.tooltip.views-today-so-far':
    '{count, plural, one {1 visualización hasta ahora} other {{count} visualizaciones hasta ahora}}',
  'confuence-analytics-chart.accessible-table.caption': 'Visualizaciones de página',
  'confuence-analytics-chart.accessible-table.header.date': 'Fecha',
  'confuence-analytics-chart.accessible-table.header.view-count': 'Visualizaciones',
  'confuence-analytics-chart.accessible-table.no-view-count-data': 'Sin visualizaciones',
};
